import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-form-footer',
  templateUrl: './form-footer.component.html',
  styleUrls: ['./form-footer.component.scss']
})
export class FormFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
